import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Typography, TextField, Button, Box, Snackbar, Alert } from '@mui/material';
import { useParams } from 'react-router-dom';

const EditarPodcast = () => {
    const { id } = useParams();
    const apiUrl = process.env.REACT_APP_API_URL;

    const [formData, setFormData] = useState({
        titulo: '',
        apresentadores: '',
        producao: '',
        roteiro: '',
        edicao: '',
        fonte: '',
        creditos: '',
        linkEpisodio: '',
        linkImagem: '',
        descricao: '',
    });

    const [alertMessage, setAlertMessage] = useState({ type: '', text: '' });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    useEffect(() => {
        const loadPodcast = async () => {
            try {
                const response = await axios.get(`${apiUrl}/podcasts/${id}`);
                setFormData(response.data);
            } catch (error) {
                console.error(error);
                setAlertMessage({ type: 'error', text: 'Erro ao carregar podcast para edição.' });
                setOpenSnackbar(true);
            }
        };
        loadPodcast();
    }, [apiUrl, id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem('token');
        if (!token) {
            setAlertMessage({ type: 'error', text: 'Você precisa estar autenticado para editar um podcast.' });
            setOpenSnackbar(true);
            return;
        }

        try {
            await axios.put(`${apiUrl}/podcasts/${id}`, formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setAlertMessage({ type: 'success', text: 'Podcast atualizado com sucesso!' });
            setOpenSnackbar(true);
        } catch (error) {
            console.error('Erro ao atualizar podcast:', error);
            setAlertMessage({ type: 'error', text: 'Erro ao atualizar podcast. Tente novamente.' });
            setOpenSnackbar(true);
        }
    };

    return (
        <Container maxWidth="lg">
            <Typography variant="h2" align="center" gutterBottom>
                Editar Podcast
            </Typography>

            <form onSubmit={handleSubmit}>
                <Box mb={3}>
                    <TextField fullWidth label="Título" name="titulo" value={formData.titulo} onChange={handleChange} required />
                </Box>
                <Box mb={3}>
                    <TextField fullWidth label="Apresentadores" name="apresentadores" value={formData.apresentadores} onChange={handleChange} />
                </Box>

                <Button fullWidth variant="contained" color="primary" type="submit">
                    Atualizar Podcast
                </Button>
            </form>

            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
                <Alert onClose={() => setOpenSnackbar(false)} severity={alertMessage.type}>
                    {alertMessage.text}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default EditarPodcast;
